import { Component } from "react";
import DataContainer from "components/utility/data-container/DataContainer";
import PropTypes from "prop-types";
import MaterialBoxDesign from "../MaterialBoxDesign";

class MaterialBoxDownload extends Component {
	render() {
		const { guid = "1234" } = this.props.dataset;

		return (
			<DataContainer data={"materialBoxDownload_" + guid}>
				<MaterialBoxDesign />
			</DataContainer>
		);
	}
}

MaterialBoxDownload.propTypes = {
	dataset: PropTypes.shape({
		materialBoxTheme: PropTypes.oneOf(["grey", "lite"]),
		assetUse: PropTypes.string,
		format: PropTypes.string,
		materialBoxTitle: PropTypes.string,
		imageUrl: PropTypes.string,
		imageAlt: PropTypes.string,
		materialBoxDescription: PropTypes.string,
		downloadUrl: PropTypes.string,
		button: PropTypes.shape({
			buttonType: PropTypes.string.isRequired, // download,
			buttonLabel: PropTypes.string,
			buttonFill: PropTypes.oneOf(["solid", "outline"]),
			dataAction: PropTypes.string,
			dataCategory: PropTypes.string,
			dataLabel: PropTypes.string
		}),
		footer: PropTypes.shape({
			instruction: PropTypes.string,
			footerLabel: PropTypes.string,
			footerLink: PropTypes.string,
			footerLinkTarget: PropTypes.string
		})
	}).isRequired
};

MaterialBoxDownload.defaultProps = {
	dataset: {
		materialBoxTheme: "grey",
		assetUse: "professional",
		format: "Research Paper",
		materialBoxTitle: "Title",
		imageUrl:
			"https://www.dimensional.com/dfsmedia/f27f1cc5b9674653938eb84ff8006d8c/61063-50071/smas-quantifying-the-tradeoffs-between-taxes-and-diversification.pdf",
		imageAlt: "image alt text",
		materialBoxDescription:
			"Description text here, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
		downloadUrl: "#",
		button: {
			buttonType: "download", // download,
			buttonLabel: "Button Label",
			buttonFill: "solid",
			dataAction: "",
			dataCategory: "",
			dataLabel: ""
		},
		footer: {
			instruction: "My Dimensional User?",
			footerLabel: "Footer Link Label",
			footerLink: "Footer Link URL",
			footerLinkTarget: "",
			dataACat: "",
			dataAAct: "",
			dataALbl: ""
		}
	}
};
export default MaterialBoxDownload;
